import LazyLoad from "react-lazyload";
import DeleteHomeData from "Screens/Admin/Components/Home/components/Delete";
import EditHomeData from "Screens/Admin/Components/Home/components/Edit";
import DeleteSocialData from "Screens/Admin/Components/Social/components/Delete";
import EditSocialData from "Screens/Admin/Components/Social/components/Edit";
import DeleteTamimaData from "Screens/Admin/Components/Tamima/components/Delete";
import EditTamimaData from "Screens/Admin/Components/Tamima/components/Edit";
import GetIcon from "./GetIcon";
import EditCharactersData from "Screens/Admin/Components/Characters/components/Edit";
import DeleteCharactersData from "Screens/Admin/Components/Characters/components/Delete";
import EditBlogsData from "Screens/Admin/Components/Blogs/components/Edit";
import DeleteBlogsData from "Screens/Admin/Components/Blogs/components/Delete";
import EditWhitepapersData from "Screens/Admin/Components/WhitePaper/components/Edit";
import DeleteWhitepapersData from "Screens/Admin/Components/WhitePaper/components/Delete";
import DeleteRoadmapData from "Screens/Admin/Components/Roadmap/components/Delete";
import SubCategoriesShow from "Screens/Admin/Components/Roadmap/components/SubCategoriesShow";
import EditRoadmapData from "Screens/Admin/Components/Roadmap/components/Edit";
import UsersEdit from "Screens/Admin/Components/Users/components/Edit";
import UsersDelete from "Screens/Admin/Components/Users/components/Delete";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

export const homeList = [
  {
    field: "title",
    headerName: "Title",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "body",
    headerName: "Body",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <EditHomeData cell={cell} row={row} />
          <DeleteHomeData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const tamimaList = [
  {
    field: "title",
    headerName: "Title",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "body",
    headerName: "Body",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <EditTamimaData cell={cell} row={row} />
          <DeleteTamimaData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const socialList = [
  {
    field: "name",
    headerName: "Name",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "link",
    headerName: "Link",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "icon",
    headerName: "Icon",
    align: "center",
    headerAlign: "center",
    renderCell: (row) => (
      <>
        {row.row.icon} <GetIcon iconKey={row.row.icon} />
      </>
    ),
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <EditSocialData cell={cell} row={row} />
          <DeleteSocialData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const charactersList = [
  {
    field: "image",
    headerName: "Image",
    align: "center",
    headerAlign: "center",
    renderCell: (row) => {
      return (
        <LazyLoad offset={0} scroll once>
          <img
            style={{ maxHeight: "65px", maxWidth: "65px", borderRadius: "4px" }}
            src={row.row.image}
          />
        </LazyLoad>
      );
    },
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "code",
    headerName: "Code",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "name",
    headerName: "Name",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "status_name",
    headerName: "Status",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "price",
    headerName: "Price",
    align: "center",
    headerAlign: "center",
    renderCell: (row) => (
      <>
        {row.row.price} {row.row.unit}
      </>
    ),
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "url",
    headerName: "url",
    align: "center",
    headerAlign: "center",
    renderCell: (row) => (
      <div className={`link-${row.row.url ? "true" : "false"}`}>
        {row.row.url ? (
          <Tooltip title={row.row.url}>
            <Link to={row.row.url} target="_blank">
              <GetIcon iconKey={"Check"} />
            </Link>
          </Tooltip>
        ) : (
          <GetIcon iconKey={"Void"} />
        )}
      </div>
    ),
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <EditCharactersData cell={cell} row={row} />
          <DeleteCharactersData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const blogsList = [
  {
    field: "image",
    headerName: "Image",
    align: "center",
    headerAlign: "center",
    renderCell: (row) => {
      return (
        <img
          style={{ maxHeight: "65px", maxWidth: "65px", borderRadius: "4px" }}
          src={row.row.image}
        />
      );
    },
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "title",
    headerName: "Title",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <EditBlogsData cell={cell} row={row} />
          <DeleteBlogsData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const whitepapersList = [
  {
    field: "image",
    headerName: "Image",
    align: "center",
    headerAlign: "center",
    renderCell: (row) => {
      return (
        <img
          style={{ maxHeight: "65px", maxWidth: "65px", borderRadius: "4px" }}
          src={row.row.image}
        />
      );
    },
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "title",
    headerName: "Title",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <EditWhitepapersData cell={cell} row={row} />
          <DeleteWhitepapersData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const roadmapList = [
  {
    field: "title",
    headerName: "Title",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "subCount",
    headerName: "Sub-Category",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <SubCategoriesShow cell={cell} row={row} />
          <EditRoadmapData cell={cell} row={row} />
          <DeleteRoadmapData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const subRoadmapList = [
  {
    field: "title",
    headerName: "Level",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "status",
    headerName: "Status",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "value",
    headerName: "Value",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <EditRoadmapData cell={cell} row={row} />
          <DeleteRoadmapData cell={cell} row={row} />
        </>,
      ];
    },
  },
];

export const usersList = [
  {
    field: "name",
    headerName: "Name",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "username",
    headerName: "Username",
    align: "center",
    headerAlign: "center",
    editable: false,
    sortable: false,
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "",
    width: 120,
    cellClassName: "actions",
    getActions: ({ cell, row }) => {
      return [
        <>
          <UsersEdit cell={cell} row={row} />
          <UsersDelete cell={cell} row={row} />
        </>,
      ];
    },
  },
];
